/**
 * Hotel level branding is only applied when the override is declared with the full short link
 * (`chainKey/hotelKey`), so two hotels sharing the same hotel key on different chains keep
 * their own branding.
 */
export function getHotelLevelBrandOverride(hotelOverrides, chainKey, hotelIdentifier) {
  if (!hotelOverrides || !chainKey || !hotelIdentifier) {
    return null
  }

  const shortLinkKey = `${chainKey}/${hotelIdentifier}`.toLowerCase()

  const matchedKey = Object.keys(hotelOverrides).find(
    key => key.toLowerCase() === shortLinkKey
  )

  if (!matchedKey) {
    return null
  }

  return {
    colors: hotelOverrides[matchedKey],
    logoKey: matchedKey.split('/')[1]
  }
}
